import { isHierarchicalPermissionsEnabled } from '@/utilities/visibleStaffSet'

export default (userTable) => {

  return {
    cols: [
      {
        name: "First Name",
        col: "firstName",
        fixed: false,
        width: "110",
        sortable: true,
        sortMethod: userTable.sortFirstName
      },
      {
        name: "Last Name",
        col: "lastName",
        fixed: false,
        width: "110",
        sortable: true,
        sortMethod: userTable.sortLastName
      },
      {
        name: "Phone",
        col: "phone",
        fixed: false,
        width: "120",
        sortable: true,
        sortMethod: (a, b) => userTable.sortByString(a.phone, b.phone)
      },
      {
        name: "Email",
        col: "email",
        fixed: false,
        width: "190",
        sortable: true,
        sortMethod: (a, b) => userTable.sortByString(a.email, b.email)
      },
      ...(isHierarchicalPermissionsEnabled() ? [{
        name: "Reports To",
        col: "reportsTo",
        fixed: false,
        width: "140",
        sortable: true,
        sortMethod: (a, b) => userTable.sortByString(a.reportsToName || '', b.reportsToName || '')
      }] : []),
      {
        name: "Last Login",
        col: "lastLogin",
        fixed: false,
        width: "120",
        sortable: true,
        sortMethod: (a, b) => userTable.sortByString(b.lastLogin, a.lastLogin)
      },
      {
        name: "Permissions",
        col: "permissions",
        fixed: false,
        width: "120",
        sortable: true,
        sortMethod: (a, b) => a.permissionLogin - b.permissionLogin
      },
      {
        name: "Roles",
        col: "roles",
        fixed: false,
        width: "220",
        sortable: true,
      },
      {
        name: undefined,
        col: "viewUser",
        fixed: "right",
        width: "50",
        sortable: false
      }
    ],

    optionsContextHeader: [
      { label: "Add User", action: 'add', divided: false },
      ...(isHierarchicalPermissionsEnabled() ? [{ label: "View Org Chart", action: 'orgChart', divided: true }] : []),
    ],

    optionsContextRow: [
      {
        label: "Mark as Owner",
        action: "markAsOwner",
        divided: false,
        condition: (row) => userTable.$store.getters.isAdmin && !row.tenantOwnerId
      },
      {
        label: "Edit User",
        action: 'edit',
        divided: false
      },
      {
        label: "ResetPassword",
        action: "reset-password",
        divided: true,
        dynamicLabel: (row) => row.lastLogin === 'NOT_YET_LOGGED' ? "Resend Temporary Password" : "Email password reset link",
        dynamicAction: (row) => row.lastLogin === 'NOT_YET_LOGGED' ? "resend-password" : "reset-password"
      },
      {
        label: "Deactivate/Reactivate",
        action: 'deactivate',
        divided: false,
        dynamicLabel: (row) => row.permissionLogin ? 'Deactivate User' : 'Reactivate User'
      },
      {
        label: "Delete User",
        action: "delete",
        divided: false,
        condition: (row) => row.lastLogin === 'NOT_YET_LOGGED'
      }
    ]
  }
}